import Vue from 'vue'

import PageNotFound from '../components/404.vue'
import Router from 'vue-router'

Vue.use(Router)
// 公共路由
export const constantRoutes = [
    // 填报信息页面
    {
        path: '/',
        name: 'Home',
        meta: {
            title: '填报车辆信息'
        },
        component: () => import('../view/Home.vue')
    },
    // 填报信息页面
    {
        path: '/home',
        name: 'Home',
        meta: {
            title: '填报车辆信息'
        },
        component: () => import('../view/Home.vue')
    },
    // 提交成功页面
    {
        path: '/SubmitSuccess',
        name: 'SubmitSuccess',
        meta: {
            title: '提交信息成功'
        },
        component: () => import('../view/SubmitSuccess.vue')
    },
    // 查看信息页面
    {
        path: '/FillCarInfo',
        name: 'FillCarInfo',
        meta: {
            title: '查看信息'
        },
        component: () => import('../view/FillCarInfo.vue')
    },
    // 查询历史填报列表
    {
        path: '/HistoryFill',
        name: 'HistoryFill',
        meta: {
            title: '查看历史填报'
        },
        component: () => import('../view/HistoryFill.vue')
    },
    {
        path: '/SubmitFail',
        name: 'SubmitFail',
        meta: {
            title: '填报失败'
        },
        component: () => import('../view/SubmitFail.vue')
    },

]
// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}

export default new Router({
    mode: 'hash', // mode: 'history', // 去掉url中的#
    // scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

// constantRoutes.beforeEach((to, from, next) => {
// // 从其他地方访问是否有这个地址
// if(to.matched.length == 0){
// from.path ? next({name: from.name}) : next('*')
// }
// next();
// });


// WEBPACK FOOTER //
// ./src/router/index.js